
export type UpdateUserProfile401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
